/**
 * @component AdminRowButton
 * @description 목록 항목의 삭제 표시·복원·추가를 수행하는 작은 원형 버튼입니다.
 * @usage HistoryAdminPanel, FaqAdminPanel의 각 편집 행에서 사용합니다.
 */

const LABELS = {
  delete: { symbol: '−', title: '삭제 표시' },
  restore: { symbol: '↺', title: '삭제 취소' },
  add: { symbol: '+', title: '항목 추가' },
  // [비즈니스] 문단 순서는 공개 페이지의 노출 순서입니다.
  up: { symbol: '↑', title: '위로 이동' },
  down: { symbol: '↓', title: '아래로 이동' },
};

// [기능] 행 편집 동작과 비활성 상태를 접근성 이름이 있는 버튼으로 표시합니다.
export default function AdminRowButton({ variant, onClick, title, disabled = false }) {
  const preset = LABELS[variant] || LABELS.delete;

  return (
    <button
      type="button"
      className={`admin-row-btn is-${variant}`}
      onClick={onClick}
      disabled={disabled}
      title={title || preset.title}
      aria-label={title || preset.title}
    >
      {preset.symbol}
    </button>
  );
}
